import React from 'react';
import { CenterContentContainer, ContentHeaderView, PageContainer, PageContentView } from 'components/shared';
/**
 * @function NoticesPage
 * @return {React.Component}
 * @exported true
 * @description The main component for NoticesPage
 */
export default function NoticesPage(props) {
  return (
    <PageContainer className="notices-page">
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="Notices"/>
          {/* Page content goes here */}
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  )
}
